module.exports = __webpack_public_path__ + "static/media/Lever de la Lune.29217308.jpg";